import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const LlmServiceDetail = React.lazy(() => import('../components/LlmServiceDetail'));

function LlmServiceDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <LlmServiceDetail {...props} />
    </Suspense>
  );
}

export default LlmServiceDetailView;
